import axios from 'axios';

export const API_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — session uses HttpOnly cookie; no Bearer from localStorage
api.interceptors.request.use(
  (config) => {
    const explicitLocationId =
      config.headers?.['X-Location-Id'] || config.headers?.['x-location-id'];
    if (!explicitLocationId) {
      const locationId = localStorage.getItem('currentLocationId');
      if (locationId) {
        config.headers['X-Location-Id'] = locationId;
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const errorResponse = error.response?.data || {
      success: false,
      error: {
        code: 'NETWORK_ERROR',
        message: 'Network error. Please check your connection.',
      },
    };

    // Handle token expiration
    if (error.response?.status === 401) {
      const errorCode = errorResponse.error?.code;
      if (errorCode === 'TOKEN_EXPIRED' || errorCode === 'INVALID_TOKEN') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }

    return Promise.reject(errorResponse);
  }
);

export default api;

